export default __webpack_public_path__ + "static/media/close-icon.2bfd233a.svg";